export default __webpack_public_path__ + "static/media/1863.f5c53fa7.png";